import { styled } from "@mui/material"

const BodyContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}))

export default BodyContainer
